// Sidebar.jsx
//import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  Typography,
  IconButton,
  //useTheme, // Import IconButton
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Chat as ChatIcon,
  Explore as ExploreIcon,
  Api as ApiIcon,
  Description as DescriptionIcon,
  Close as CloseIcon,
  ArrowBackOutlined, // Import CloseIcon
} from '@mui/icons-material';
import Subscription from '@mui/icons-material/AddCard';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import ConversationItem from './conversationComponent';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import React, { useState } from 'react';
import { Modal,Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import WebsiteIcon from '@mui/icons-material/Language'
// import ExploreIcon from '@mui/icons-material/Explore'
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
//import ArticleIcon from '@mui/icons-material/Article';
import ArticleIcon from '@mui/icons-material/Newspaper';
import PublicIcon from '@mui/icons-material/Public'; // Importing PublicIcon
import HistoryIcon from "@mui/icons-material/History";
import SubscriptionIcon from "@mui/icons-material/Subscriptions";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import Redeem from '@mui/icons-material/Redeem';

import { ArrowBack } from '@mui/icons-material';
import Referral from '../Referral';
const SparklyBadge = () => (
  <Box
    sx={{
      position: 'relative',
      display: 'inline-block',
      marginLeft: '8px',
    }}
  >
    {/* Badge Background */}
    <Box
      sx={{
        backgroundColor: 'red',
        color: 'white',
        fontSize: '10px',
        fontWeight: 'bold',
        borderRadius: '8px',
        padding: '2px 6px',
        position: 'relative',
        zIndex: 2,
      }}
    >
      New
    </Box>

    {/* Sparkle Effect */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '8px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 70%)',
        animation: 'sparkle 1.5s infinite',
        zIndex: 1,
        pointerEvents: 'none', // Ensures it doesn’t interfere with interactions
      }}
    />
    <style>
      {`
        @keyframes sparkle {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.5);
            opacity: 0;
          }
        }
      `}
    </style>
  </Box>
);


const Sidebar = ({
  isOpen,
  handleCloseSidebar,
  toggleSidebar,
  menuFontSize = '16px',
  conversationFontSize = '10px',
  createConversation,
  isMdUp
}) => {
  const sidebarWidth = 250; // You can adjust this value as needed

  const {
    version,
    setVersion,
    currentConversation,
    conversations,
    setConversations,
    setCurrentConversation,
    queries,
    setQueries,
    ids,
    setIds,
    idHistory,
    setIdHistory,
    setMode,
    setLink,
    errorDisplay,
    setErrorDisplay,
    setIsSearchMoved,
    setNewSearch,
  } = useAppContext();

  const handleConversationSelect = (conversation) => {
    setErrorDisplay("");
    toggleSidebar()
    setNewSearch(false);
    if (currentConversation !== conversation.id) {
      setQueries([]); // Reset queries or any other state related to conversations if needed
      setIds([]);
      setIdHistory({});
      setCurrentConversation(conversation.id);
    }
  };
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [sidebarOpen, setSidebarOpen] = useState(isOpen); // State to control sidebar open/close


  // const toggleSidebar = () => {
  //   setSidebarOpen(!sidebarOpen); // Toggle the sidebar open/close
  // };

  const toggleHistoryVisibility = () => {
    setShowHistory(!showHistory); // Toggle the visibility of the conversations list
  };

  const [showHistory, setShowHistory] = useState(false); // State to toggle visibility of conversation list
  //const isMdUp = useMediaQuery("(min-width:600px)");
  const theme = useTheme()

  return (
   
    <Drawer
    anchor="left"
    open={isOpen}
    //open = {sidebarOpen}
    onClose={handleCloseSidebar}
    //variant={isMdUp ? "persistent" : "temporary"}
    variant = 'temporary'
    ModalProps={{ keepMounted: true }}
    sx={{
      "& .MuiDrawer-paper": {
        width: isMdUp ? 260 : 240,
        boxSizing: "border-box",
        p: 2,
        display: "flex",
        flexDirection: "column",
        height: "100vh", // Ensure the sidebar takes up full height,
        overflowY: "auto"
      },
    }}
  >
     {/* {console.log(isOpen)} */}
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>

        {/* Sidebar Toggle Button (Hamburger or Close) */}
        {isOpen && !showHistory && (
  <Box sx={{ padding: "16px 0", display: "flex", justifyContent: "flex-start" }}>
    <Button
      onClick={toggleSidebar}
      sx={{
        color: "rgb(0, 102, 255)",  // Blue color for the arrow
        backgroundColor: "#F1F3FE",  // Light blue background for the arrow
        borderRadius: "16px",  // Chip-style rounded corners
        padding: "4px 12px",   // Smaller padding for a compact look
        fontSize: "14px",  // Smaller font size for a badge-like feel
        textTransform: "none",  // Prevent text transformation (no uppercase)
        boxShadow: "none",  // No shadow for a cleaner look
        '&:hover': {
          backgroundColor: "#E1E5FB",  // Subtle hover effect with a slightly darker light blue
        },
      }}
    >
      <ArrowBack sx={{ fontSize: "20px" }} />  {/* Use ArrowBack icon with blue theme */}
    </Button>
  </Box>
)}




      
        {/* LOGO - Conditional Display */}
        {/* {!showHistory && sidebarOpen && (
          <Box sx={{ padding: "16px 0", display: "flex", justifyContent: "center" }}>
            <a href="https://facticity.ai" style={{ textDecoration: "none" }}>
              <img
                src="/facticityailogo-03.png"
                alt="Facticity.AI"
                style={{
                  width: "28px",
                  height: "auto",
                }}
              />
            </a>
          </Box>
        )} */}

      {!showHistory && (
        <Divider />
      )}

      {!showHistory && (
        <List
        sx={{
          flexGrow: 1,
          p: 0,
          "& .MuiListItemButton-root": {
            [theme.breakpoints.down("sm")]: { py: 0.5, minHeight: 36 },
          },
          "& .MuiListItemIcon-root": {
            [theme.breakpoints.down("sm")]: { minWidth: 32 },
          },
          "& .MuiTypography-root": {
            [theme.breakpoints.down("sm")]: { fontSize: 14 },
          },
        }}
      >
        <Tooltip title="Return to the main Facticity landing page" placement="right" arrow>
          <ListItemButton component={Link} to="https://facticity.ai" target="_blank">
            <ListItemIcon><PublicIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Facticity.AI Main Page" />
          </ListItemButton>
        </Tooltip>
      
        <Tooltip title="See what our community is talking about." placement="right" arrow>
          <ListItemButton component={Link} to="/discover">
            <ListItemIcon><ExploreIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Discover" />
          </ListItemButton>
        </Tooltip>
      
        {/* <Tooltip title="Check out our Facticity blogs!" placement="right" arrow>
          <ListItemButton component={Link} to="/blog">
            <ListItemIcon><ArticleIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Blog" />
          </ListItemButton>
        </Tooltip> */}
      
        <Tooltip title="Try it out now!" placement="right" arrow>
          <ListItemButton component={Link} to="/writer">
            <ListItemIcon><DescriptionIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Writer" />
          </ListItemButton>
        </Tooltip>
      
        <ListItemButton component={Link} to="/api">
          <ListItemIcon><ApiIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="API" />
        </ListItemButton>

        <ListItemButton component={Link} to="/rewards">
          <ListItemIcon><Redeem fontSize="small" /></ListItemIcon>
          <ListItemText primary="Referrals & Redeem" />
        </ListItemButton>
      
        <ListItemButton component={Link} to="/subscription">
          <ListItemIcon><Subscription fontSize="small" /></ListItemIcon>
          <ListItemText primary="Subscription" />
        </ListItemButton>
      
        <ListItemButton onClick={(e) => { e.stopPropagation(); createConversation(); }}>
          <ListItemIcon><EditNoteIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="New Chat" />
        </ListItemButton>
      
        <ListItemButton onClick={toggleHistoryVisibility}>
          <ListItemIcon><HistoryIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="View History" />
        </ListItemButton>
      </List>
      
      )}

      {/* If showHistory is true, show the conversation list and collapse button */}
      {showHistory && (
        <Box sx={{ flexGrow: 1, 
          overflowY: "auto", // Make the conversation list scrollable
          height: "calc(100vh - 120px)", // Adjust to fit within the sidebar with space for the toggle button
          paddingRight: "8px", }}>
          {/* Sticky Collapse History button */}
          <List sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
  <ListItemButton
    onClick={toggleHistoryVisibility}
    sx={{
      backgroundColor: "#F1F3FE",  // Light blue background
      borderRadius: "16px",  // Rounded corners for a chip-like effect
      '&:hover': {
        backgroundColor: "#E1E5FB",  // Slightly darker blue on hover
      },
      padding: { xs: "6px 12px", sm: "8px 16px" },  // Adjust padding based on screen size (smaller on mobile)
      width: { xs: "auto", sm: "fit-content" },  // Auto width on mobile and fit-content on larger screens
    }}
  >
    <ListItemIcon>
      <ArrowBackOutlined sx={{ color: "rgb(0, 102, 255)", fontSize: { xs: "18px", sm: "20px" } }} />  
      {/* Adjust icon size based on screen size */}
    </ListItemIcon>
    <ListItemText 
      primary="Close History" 
      sx={{ 
        color: "rgb(0, 102, 255)", 
        fontSize: { xs: "12px", sm: "14px" },  // Adjust text size based on screen size
        display: { sm: "block" },  // Hide text on mobile and show on larger screens
      }} 
    />
  </ListItemButton>
</List>


          {/* Conversations List */}
          <List sx={{ overflowY: "auto", maxHeight: "calc(100vh - 120px)" }}>
            {conversations.slice().reverse().map((conversation) => (
              <ConversationItem
               key={conversation.id}
               conversation={conversation}
               currentConversation={currentConversation}
               handleConversationSelect={handleConversationSelect}
               conversationItemStyle={{
                 fontSize: conversationFontSize,
                 paddingLeft: '24px',
                 wordBreak: 'break-all',
                 overflowWrap: 'break-word',
                 margin: '4px 0',
                 padding: '6px 12px',
                 borderRadius: '8px',
                 '&.Mui-selected': {
                   backgroundColor: '#F1F3FE',
                   '&:hover': {
                     backgroundColor: '#F1F3FE',
                   },
                 },
               }}
             />
            ))}
          </List>
        </Box>
      )}

      {/* Footer: Settings & Socials */}
      {!showHistory && (
        <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginTop: "auto",
          padding: "16px 0",
          [theme.breakpoints.down("sm")]: { padding: "8px 0" }, // Less padding on mobile
        }}
      >
        {/* Settings Button */}
        <ListItemButton
  component={Link}
  to="/settings"
  sx={{
    padding: "12px 16px", // Default padding
    "& .MuiListItemIcon-root": {
      minWidth: "36px", // Default icon size
    },
    "& .MuiTypography-root": {
      fontSize: "1rem", // Default text size
    },
    "@media (max-width:600px)": {
      padding: "8px 12px", // Smaller padding on mobile
      "& .MuiListItemIcon-root": {
        minWidth: "28px", // Smaller icon spacing
      },
      "& .MuiTypography-root": {
        fontSize: "0.85rem", // Smaller text on mobile
      },
    },
  }}
>
  <ListItemIcon>
    <SettingsIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> {/* Adjust icon size */}
  </ListItemIcon>
  <ListItemText primary="Settings" />
</ListItemButton>

        <Divider />

        {/* Footer: Social Media Links */}
        <Box
          sx={{
            textAlign: "center",
            mt: 2,
            pb: 2, // Extra padding at the bottom
            [theme.breakpoints.down("sm")]: {
              mt: 1,
              pb: 3, // Ensures space on mobile
            },
          }}
        >
          <Typography sx={{ color: "grey.800", fontWeight: "bold", fontSize: 14 }}>
            <a href="https://www.aiseer.co" target="_blank" style={{ color: "grey" }}>
              AI Seer
            </a>
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1.5,
              flexWrap: "wrap", // Allow wrapping in smaller screens
              mt: 1,
              [theme.breakpoints.down("sm")]: { gap: 1 }, // Reduce gap on mobile
            }}
          >
            <a href="https://www.aiseer.co" target="_blank"><WebsiteIcon sx={{ color: "grey.600", fontSize: 20 }} /></a>
            <a href="https://www.linkedin.com/company/aiseer" target="_blank"><LinkedInIcon sx={{ color: "grey.600", fontSize: 20 }} /></a>
            <a href="https://x.com/facticityai" target="_blank"><XIcon sx={{ color: "grey.600", fontSize: 20 }} /></a>
            <a href="https://www.instagram.com/facticity.ai/" target="_blank"><InstagramIcon sx={{ color: "grey.600", fontSize: 20 }} /></a>
            <a href="https://www.youtube.com/@facticityai" target="_blank"><YouTubeIcon sx={{ color: "grey.600", fontSize: 20 }} /></a>
          </Box>
        </Box>
      </Box>
      )}
    </Box>
  </Drawer>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseSidebar: PropTypes.func.isRequired, // Corrected prop name
  menuFontSize: PropTypes.string,
  conversationFontSize: PropTypes.string,
  createConversation: PropTypes.func.isRequired, // Added missing prop type
};

export default Sidebar;
